import { render, staticRenderFns } from "./userPact.vue?vue&type=template&id=0e9bd400&scoped=true"
var script = {}
import style0 from "./userPact.vue?vue&type=style&index=0&id=0e9bd400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9bd400",
  null
  
)

export default component.exports